import { render, staticRenderFns } from "./Optins.vue?vue&type=template&id=6dbaf595"
import script from "./Optins.vue?vue&type=script&lang=js"
export * from "./Optins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dbaf595')) {
      api.createRecord('6dbaf595', component.options)
    } else {
      api.reload('6dbaf595', component.options)
    }
    module.hot.accept("./Optins.vue?vue&type=template&id=6dbaf595", function () {
      api.rerender('6dbaf595', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Optins.vue"
export default component.exports